<div class="filter-box dz-flex dz-align-items-center-xl padding-object-4-xl padding-object-3-md" (click)="applyFilter(filter)" [ngClass]="{ checked: isChecked }" tabindex="0">
	<span class="padding-right-object-2" aria-hidden="true">
		<dz-pictogram [name]="icon" size="small"></dz-pictogram>
	</span>
	<span class="filter-text dz-text-md-14-bold dz-text-lg-16-bold" [dcrHTMLKey]="'HIGHLIGHTEDFILTER_' + filter.meFilterId">{{ filter.meFilterId }}</span>
</div>
